// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__25EUy","author":"Table_author__NnBFz","authorImage":"Table_authorImage__poNcS","unreadRow":"Table_unreadRow__1ySll"};